import { render } from "./ScoreHBH.vue?vue&type=template&id=d9d50ee2&scoped=true"
import script from "./ScoreHBH.vue?vue&type=script&lang=js"
export * from "./ScoreHBH.vue?vue&type=script&lang=js"

import "./ScoreHBH.vue?vue&type=style&index=0&id=d9d50ee2&scoped=scoped&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit\\f_pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d50ee2"]])

export default __exports__